import { useCallback, useReducer } from "react";

import {
  onSignIn,
  onSignInFacebook as onSignInFacebookAPI,
} from "../services/auth";

import { SignInForm, ActionSignIn, UseSignIn } from "../interfaces/auth";

const initialState = {
  loading: false,
  userNoMatch: false,
} as UseSignIn;

const reducer = (state: UseSignIn, action: ActionSignIn) => {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.value,
      };
    case "userNoMatch":
      return {
        ...state,
        userNoMatch: action.value,
      };
    default:
      return state;
  }
};

export const useSignIn = (fields: SignInForm, cb = (value: any) => {}) => {
  const [{ loading, userNoMatch }, dispatch] = useReducer(
    reducer,
    initialState
  );

  const onLogin = useCallback(() => {
    dispatch({ type: "loading", value: true });
    onSignIn(fields)
      .then(({ data }) => {
        dispatch({ type: "loading", value: false });
        if (data.error) {
          dispatch({ type: "userNoMatch", value: true });
        } else {
          cb(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [fields, cb]);

  const onSignInFacebook = useCallback((token) => {
    dispatch({ type: "loading", value: true });
    onSignInFacebookAPI(token)
      .then(({ data }) => {
        dispatch({ type: "loading", value: false });
        cb(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return {
    loading,
    onLogin,
    userNoMatch,
    setLoading: (cb: () => boolean) =>
      dispatch({ type: "loading", value: cb() }),
    cancelUserNoMatch: () => dispatch({ type: "userNoMatch", value: false }),
    onSignInFacebook,
  };
};
